export const painPoints = [
  {
    emoji: '🧭',
    title: 'Vous ne savez pas par où commencer',
    desc: 'Le processus de rééducation semble insurmontable. Cette méthode organise tout : bilan, phase aiguë, renforcement progressif et retour au sport.',
  },
  {
    emoji: '🔤',
    title: 'Vous bloquez sur le choix des exercices',
    desc: 'Apprenez de manière guidée à reconnaître les modèles de progression et à prescrire avec intention.',
  },
  {
    emoji: '🧩',
    title: "Vous n'arrivez pas à construire un protocole complet",
    desc: 'Apprenez la structure complète des phases pour des protocoles qui font sens dès le premier jour.',
  },
  {
    emoji: '💭',
    title: 'Vous oubliez les critères de progression',
    desc: 'Obtenez des points de contrôle concrets pour que votre prescription progresse réellement au lieu de stagner.',
  },
  {
    emoji: '🎯',
    title: 'Vous craignez la récidive',
    desc: 'Deviner est dangereux. Un cadre clair de retour au sport est ce qui garde les athlètes en sécurité.',
  },
];
